<div *ngIf="!prerequisiteError" #prizmdocViewerContainer [style.width]="width" [style.height]="height"></div>
<mat-card *ngIf="prerequisiteError" class="prizmdoc-error-card" role="alert">
  <h2 class="prizmdoc-error-title">Error Loading Viewer Prerequisites</h2>
  <p class="prizmdoc-error-text">
    There was a problem loading the required JavaScript and CSS files which the viewer depends on:
  </p>
  <pre class="prizmdoc-error-message">
    {{prerequisiteError.message}}
  </pre>
  <p class="prizmdoc-error-text">Make sure that:</p>
  <ul>
    <li>You have added the static <code>viewer-assets</code> directory to your web application.</li>
    <li>You have configured a static route in your web application to serve the <code>viewer-assets</code>.</li>
    <li>You have configured the <code>VIEWER_ASSETS_BASE_ROUTE</code> in <code>prizmdoc-viewer-wrapper.component.ts</code> to use the correct base route to the static <code>viewer-assets</code>.</li>
  </ul>
</mat-card>
